import { useAppSelector } from 'app/hooks';
import { APPROVAL_STATUS_ALL, DELIVERY_STATUS_ALL } from 'features/Delivery/constants';
import { selectDeliveryApprovalStatus, selectDeliveryDeliveryStatus } from 'features/Delivery/deliverySlice';
import { DeliverySearchPayload } from 'features/Delivery/models/delivery';
import moment from 'moment';
import { useRef, useState } from 'react';
import { Accordion, Col, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { DATE_HYPHEN_FORMAT } from 'utils';
import CustomInputDatePicker from '../CustomInputDatePicker';

export interface SearchDeliveryProps {
  onSubmit?: (payload: DeliverySearchPayload) => void;
}

const SearchDelivery = ({ onSubmit }: SearchDeliveryProps) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(moment().subtract(1, 'weeks').toDate());
  const [endDate, setEndDate] = useState(moment().add(1, 'weeks').toDate());
  // ref
  const approvalStatusRef = useRef<HTMLSelectElement>(null);
  const deliveryStatusRef = useRef<HTMLSelectElement>(null);

  //selector
  const deliveryStatusList = useAppSelector(selectDeliveryDeliveryStatus);
  const approvalStatusList = useAppSelector(selectDeliveryApprovalStatus);

  const handleSearch = () => {
    onSubmit?.({
      start_date: moment(startDate).format(DATE_HYPHEN_FORMAT),
      end_date: moment(endDate).format(DATE_HYPHEN_FORMAT),
      approval_status: approvalStatusRef.current?.value || APPROVAL_STATUS_ALL,
      delivery_status: Number(deliveryStatusRef.current?.value || DELIVERY_STATUS_ALL),
    });
  };

  return (
    <Accordion className="mb-3" defaultActiveKey={['0', '1', '2']} alwaysOpen>
      <Accordion.Item eventKey="0" className="movement-information">
        <Accordion.Header> {t('DeliveryFeature.Text.delivery_history_search')} </Accordion.Header>
        <Accordion.Body>
          <div className="row">
            <div className="col-12 col-xxl-8">
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                <Form.Label column sm="1">
                  {t('DeliveryFeature.Text.delivery_date')}
                </Form.Label>
                <Col sm="4" className="d-flex align-items-center">
                  <div className="d-flex" style={{ maxWidth: '110px' }}>
                    <DatePicker
                      locale="ja"
                      selected={startDate}
                      dateFormat="yyyy-MM-dd"
                      onChange={(date: Date) => {
                        setStartDate(date);
                      }}
                      selectsStart
                      startDate={startDate}
                      endDate={endDate}
                      customInput={<CustomInputDatePicker />}
                    />
                  </div>
                  <span className="pe-3 ps-3">～</span>
                  <div className="d-flex" style={{ maxWidth: '110px' }}>
                    <DatePicker
                      locale="ja"
                      selected={endDate}
                      dateFormat="yyyy-MM-dd"
                      onChange={(date: Date) => {
                        setEndDate(date);
                      }}
                      selectsEnd
                      startDate={startDate}
                      endDate={endDate}
                      minDate={startDate}
                      customInput={<CustomInputDatePicker />}
                    />
                  </div>
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                <Form.Label column sm="1">
                  {t('DeliveryFeature.Text.approval_state')}
                </Form.Label>
                <Col sm="auto">
                  <div className="d-flex" style={{ minWidth: '150px' }}>
                    <Form.Select className="text-center" ref={approvalStatusRef}>
                      <option key={APPROVAL_STATUS_ALL} value={APPROVAL_STATUS_ALL}>
                        {t('DeliveryFeature.Text.all')}
                      </option>
                      {approvalStatusList.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </div>
                </Col>

                <Form.Label column sm="1">
                  {t('DeliveryFeature.Text.delivery_status')}
                </Form.Label>
                <Col sm="auto">
                  <div className="d-flex" style={{ minWidth: '150px' }}>
                    <Form.Select className="text-center" ref={deliveryStatusRef}>
                      <option key={DELIVERY_STATUS_ALL} value={DELIVERY_STATUS_ALL}>
                        {t('DeliveryFeature.Text.all')}
                      </option>
                      {deliveryStatusList.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </div>
                </Col>
              </Form.Group>
            </div>
          </div>
          <div className="d-grid gap-2 d-md-flex justify-content-md-end">
            <button className="btn btn-primary me-md-2" type="button" onClick={handleSearch}>
              {t('DeliveryFeature.Component.search')}
            </button>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default SearchDelivery;
